import React, { useEffect } from "react";
import { useParams } from "react-router-dom";


function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

const PayOnlinePage = () => {
  const { order_id } = useParams();

  useEffect(() => {

    async function initiatePayment() {
      const res = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );
      if (!res) {
        alert("Razorpay failed to load!");
        return;
      }

      if (!order_id) {
        alert("Order ID is missing!");
        return;
      }

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY || "rzp_test_TTXMLV0ERseASl", // Replace with your Razorpay key or use env var
        amount: 50000, // Amount in subunits (50000 = 500.00 INR)
        currency: "INR",
        name: "Acme Corp",
        description: "Test Transaction",
        order_id: order_id, // Use the dynamic order ID from the URL
        prefill: {
          name: "Gaurav Kumar",
          email: "gaurav.kumar@example.com",
          contact: "9999999999",
        },
        theme: {
          color: "#F37254",
        },
        handler: function (response) {
          alert(`Payment ID: ${response.razorpay_payment_id}`);
          alert(`Order ID: ${response.razorpay_order_id}`);
          alert(`Signature: ${response.razorpay_signature}`);
        },
        modal: {
          ondismiss: function () {
           
          },
        },
      };


      if (window.Razorpay) {
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
      } else {
        alert("Razorpay SDK not loaded!");
      }
    }

    initiatePayment(); // Trigger Razorpay checkout automatically on page load
  }, [order_id]); // Re-run the effect when order_id changes

  return (
    <div>
      <h1>Redirecting to Razorpay Checkout...</h1>
      <p>
        If you are not redirected, please check your browser's popup settings.
      </p>
    </div>
  );
};

export default PayOnlinePage;
